import React, { useState, useContext } from "react"
import styled from "styled-components"
import BlockContent from "@sanity/block-content-to-react"
import { MEDIA_MIN_MEDIUM } from "../../../../constants"
import { BrinkContext } from "../../../context/BrinkContext"

const Contianer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 1.5rem 0 1.5rem;
  margin: 0;
  border-top: 0.1rem solid ${(p) => p.theme.colors.lightBorder};

  > div {
    width: 100%;
  }

  ${MEDIA_MIN_MEDIUM} {
    padding: 2.5rem 0;
  }

  &:last-of-type {
    border-bottom: 0.1rem solid ${(p) => p.theme.colors.lightBorder};
  }
`

const Title = styled.h4`
  width: 100%;
  padding: 0 3rem 0 0;
  position: relative;
  cursor: pointer;
  font-size: 1.6rem;
  margin: 0;

  i {
    font-size: 1.6rem;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -0.7rem;

    ${MEDIA_MIN_MEDIUM} {
      top: 0.4rem;
      font-size: 2rem;
      margin-top: 0;
    }
  }
`

const Text = styled.div`
  padding: 2rem;
  margin: 2rem 0 1rem;
  width: 100%;
  background: ${(p) => p.theme.colors.background};
  line-height: 2.6rem;

  ${MEDIA_MIN_MEDIUM} {
    padding: 2rem 3rem;
    margin: 2.5rem 0 0;
  }
`

const Tab = ({ tab }) => {
  const { languageCode } = useContext(BrinkContext)
  const [expanded, setExpanded] = useState(null)

  if (!tab) return null
  const { title, text } = tab

  return (
    <Contianer>
      <Title onClick={() => setExpanded(!expanded)}>
        {title[languageCode] || title.en || title}
        {expanded ? (
          <i className="fal fa-minus"></i>
        ) : (
          <i className="fal fa-plus"></i>
        )}
      </Title>
      {expanded && (
        <Text>
          {text.en ? (
            <BlockContent
              blocks={text[languageCode]._rawText || text.en._rawText}
            />
          ) : (
            text
          )}
        </Text>
      )}
    </Contianer>
  )
}

export default Tab
